/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { DiagnosticProcedureBodyDtoCategoryOfTest } from './diagnosticProcedureBodyDtoCategoryOfTest';

export interface DiagnosticProcedureBodyDto {
  /** Category of test */
  categoryOfTest?: DiagnosticProcedureBodyDtoCategoryOfTest;
  /** Extra test information */
  extraTestInformation?: string;
  /** Number of positive tests */
  numberOfPositiveTests?: number;
  /** Number of negative tests */
  numberOfNegativeTests?: number;
  /** Total number of tests */
  numberOfTests?: number;
  /** Sample type code */
  sampleTypeCode?: string;
  /** Sub category code */
  subCategoryCode?: string;
  /** Family code */
  familyCode?: string;
}
